<template>
  <div
    class="orm-mb-16 orm-col-xs-12 orm-col-sm-8 orm-col-md-4 orm-col-lg-3 orm-px-xs-8"
    v-if="filter"
    :rel="JSON.parse(JSON.stringify(car.toString()))"
  >
    <div class="text-center">
      <div class="orm-slider__imagecontainer" v-if="images">
        <div class="orm-topseller" v-if="car.is_top">
          <span class="orm-topseller__icon"
            ><i class="fas fa-thumbs-up"></i
          ></span>
          <span class="orm-topseller__icon_text">Top-Seller</span>
        </div>
        <img v-if="images.length > 0" :src="images[0].image" alt="" />
        <div
          v-else
          :style="{ paddingTop: '56.25%' }"
          style="background-color: #fff;box-shadow: 0 14px 20px #fff;"
        ></div>
      </div>
      <div class="orm-px-sm-56 orm-pt-16">
        <div class="orm-cattitle orm-mb-16">
          {{ stripHTML(data[env.VUE_APP_RESERVATION_CARGROUP]) }}
        </div>
        <p v-if="car.auto_abo_min_price">ab {{ convertCurrency(car.auto_abo_min_price) }} / Monat</p>
        <p v-else>&nbsp;</p>
        <div v-if="!loading">
          <button
              v-if="!loading"
              @click="setCarGroup(car)"
              class="orm-btn orm-btn--outline"
              :disabled="car.auto_abo_min_price == null"
          >
            {{ car.auto_abo_min_price == null ? i18n("cargroup/notAvailable") || 'Ausgebucht' : i18n("cargroup/select") }}
          </button>
        </div>
        <div class="orm-price__txt text-center orm-mb-32 orm-mt-32" v-else>
          <i class="fa fa-spinner-third orm-rotate360"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import store from "@/store";
import equipIcon from "@/components/reservation/equip-icon.vue";
// import Slider from "@/components/ui/image-slider.vue";
import { convertCurrency } from "@/constants/formater";
import i18n from "@/mixins/mixins";
import stripHTML from "@/mixins/mixins";
import { buildDataLayer } from "@/constants/analytics";
import { routeToSteps } from "@/constants/getRoutes";

export default defineComponent({
  name: "AboCarGroup",
  components: {},
  mixins: [i18n, stripHTML],
  setup() {
    const userSession = store.state.userSession.LocalSession;

    return {
      userSession,
      store,
      convertCurrency,
      routeToSteps,
    };
  },
  data() {
    return {
      car: Object,
      price: [],
      isOffer: false,
      images: null,
      show: true,
      loading: false,
      env: process.env,
    };
  },
  props: {
    data: Object,
    filter: Boolean,
  },
  async mounted() {
    this.car = await JSON.parse(JSON.stringify(this.data));

    const observer = new IntersectionObserver((entries) => {
      // Use `intersectionRatio` because of Edge 15's
      // lack of support for `isIntersecting`.
      // See: https://github.com/w3c/IntersectionObserver/issues/211
      if (entries[0].intersectionRatio <= 0) return;
      // Cleanup the observer when it's not
      // needed anymore.
      observer.unobserve(this.$el);
      // The `loadPrice()` resolves
      // to the result of a dynamic `import()`
      // which is passed to the `resolveComponent()`
      // function.
      this.lazyload();
    });
    // We observe the root `$el` of the
    // mounted loading component to detect
    // when it becomes visible.
    observer.observe(this.$el);
  },
  emits: ["openContact"],
  methods: {
    async lazyload() {
      const car = [];

      // await store
      //   .dispatch("cargroup/SET_CARGROUP_IMAGE", this.car.id)
      //   .then((val) => (this.images = val));
      this.images = this.car.images;
    },
    setCarGroup(car) {
      store.dispatch("userSession/SET_CARGROUP_ABO", car.id).then(() => {
        store.dispatch("userSession/SET_ABO_VEHICLEGROUP", {[car.id]: true}).then(() => {
            store.dispatch("userSession/SWITCH_STATIONTYPE", 'ABO').then(() => {
              store.dispatch("userSession/SET_STATIONBRANCH", 'Auto-Abo').then(() => {
                store.dispatch("reservation/DELETE_TARIF");
                store.dispatch("reservation/SET_DRIVEDISTANCE", null);
                store.dispatch("stations/SET_OPENINGTIMES").then(() => {
                  routeToSteps(this, 1);
                })
            })
          })
        })
      });
    },
    openContactModal(car) {
      this.$emit("openContact", car);
    },
  },
});
</script>
